import {
  Avatar,
  Chip,
  ExternalLinkAltIcon,
  IconButton,
  Link,
  ProfileHeader,
  Theme,
  Typography,
  createStyles,
  makeStyles,
  useRouter,
} from '@forgeglobal/design-framework'
import { formatEnumByLabel } from 'util/EnumUtils'
import { offeringTypes } from 'util/Enums'
import { useGetOfferingQuery } from 'graphql/bindings/AdminBindings'
import React, { Fragment } from 'react'
import compact from 'lodash/compact'

import { Routes } from 'util/Routes'
import { createStatusChip } from './CampaignHelpers'

interface CampaignHeaderProps {
  type: 'singleItemPage' | 'form'
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionContainer: {
      display: 'flex',
      alignItems: 'center',
    },
  })
)

export const CampaignHeader: React.FC<CampaignHeaderProps> = ({ type }) => {
  const { match } = useRouter<{
    id: string
  }>()
  const campaignId = match.params.id
  const { data } = useGetOfferingQuery({ variables: { id: campaignId } })

  const offering = data?.offering
  const owners = offering?.primary_contacts ?? []

  const classes = useStyles()

  const ownerChips = owners.map(owner => {
    return (
      <Chip
        key={`${owner.first_name}${owner.last_name}${owner.id}`}
        avatar={<Avatar />}
        label={`${owner.first_name} ${owner.last_name}`}
      />
    )
  })

  const details = compact([
    {
      icon: (
        <div>
          <Typography>{formatEnumByLabel(offering?.offering_type ?? '', offeringTypes)}</Typography>
          {ownerChips.length === 0 ? <Chip color="primary" label="No owner found" /> : ownerChips}
        </div>
      ),
      content: <Fragment />,
    },
  ])

  return (
    <ProfileHeader
      title={offering?.name !== '' ? offering?.name : 'Unnamed Campaign'}
      subtitle=""
      avatarImg={offering?.company?.logo_url ?? ''}
      details={details}>
      <div className={classes.actionContainer}>
        {createStatusChip(offering?.status ?? '')}
        {offering?.status !== 'Draft' && (
          <Link href={Routes.platformOfferingPage(offering?.token ?? 'not_found')} target="_blank">
            <IconButton>
              <ExternalLinkAltIcon />
            </IconButton>
          </Link>
        )}
      </div>
    </ProfileHeader>
  )
}
